import { Link, useLocation } from "react-router-dom";

export default function NotFoundPage() {
  const { pathname } = useLocation();

  return (
    <section className="not-found-page" aria-labelledby="not-found-title">
      <p className="not-found-code">404</p>
      <h1 id="not-found-title">यो पृष्ठ भेटिएन</h1>
      <p>
        <strong>{pathname}</strong> ठेगानामा कुनै पृष्ठ उपलब्ध छैन।
      </p>
      <Link className="btn-primary not-found-home" to="/">
        गृहपृष्ठमा फर्कनुहोस्
      </Link>
    </section>
  );
}
